<template>
  <div class="rd-legacy">
    <report-tools copy @copy="copyTables"></report-tools>
    <div ref="host">
      <component
        :is="component"
        ref="tab"
        v-bind="componentProps"
        @switch-tab="(index) => $emit('switch-tab', index)"
      ></component>
    </div>
  </div>
</template>

<script>
import ReportTools from "../ReportTools.vue";
import { copyText, rowsToTsv } from "../copyTable";

/**
 * Stari tab izveštaja u novoj ljusci: ima svoje učitavanje, izbore, štampu i Excel,
 * a period i pretragu čita iz zajedničkog stanja (store report), kao i do sada.
 * Gustina i kopiranje tabele rade nad prikazanim tabelama (tekst iz stranice).
 */
export default {
  name: "ReportDesktopLegacy",
  components: { ReportTools },
  props: {
    component: {
      type: [Object, Function],
      required: true,
    },
    componentProps: {
      type: Object,
      default: () => ({}),
    },
    /** Stari tab koji uči tek kad se promeni izbor (admin tabovi izveštaja gostiju) učitava i pri otvaranju. */
    loadOnMount: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const tab = this.$refs.tab;
    if (this.loadOnMount && tab && !tab.isLoading) {
      const load = tab.loadCompanies || tab.loadData;
      if (typeof load === "function") {
        load.call(tab);
      }
    }
  },
  methods: {
    /** Sve prikazane tabele kao tekst razdvojen tabulatorima (firme jedna ispod druge). */
    async copyTables() {
      const tables = [...this.$refs.host.querySelectorAll("table")];
      const blocks = tables
        .map((table) => {
          const rows = [...table.querySelectorAll("tr")]
            .map((row) =>
              [...row.querySelectorAll("th, td")].map((cell) => cell.innerText.replace(/\s+/g, " ").trim())
            )
            .filter((cells) => cells.some(Boolean));
          if (!rows.length) {
            return "";
          }
          const card = table.closest(".company-card, .v-card");
          const title = card?.querySelector(".company-title, h2, .v-card__title")?.innerText.trim();
          const text = rowsToTsv(rows[0], rows.slice(1));
          return title ? `${title}\n${text}` : text;
        })
        .filter(Boolean);
      if (!blocks.length) {
        this.$emit("toast", this.$t("report_desktop.nothing_to_copy"));
        return;
      }
      const copied = await copyText(blocks.join("\n\n"));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
